import request from '@/utils/request'
import { Message } from 'element-ui'
import Qs from 'qs'
/**
 *文件下载
 */
export function exportFile(url,params,method) {
  return new Promise((resolve, reject) => {
    request({
        url: url,
        params: params,
        paramsSerializer: function(params) {
          return Qs.stringify(params, { arrayFormat: 'repeat' })
        },
        responseType: 'blob',
        method: method || 'post'
    }).then(res=>{
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = decodeURIComponent(res.headers.filename);
        if(fileName == 'undefined'){
            Message({
              message: '没有数据',
              type: 'error',
              duration: 5 * 1000
            })
            reject(fileName);
            return;
        }
        if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
        } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
        }
      resolve(fileName);
    }).catch(res=>{
      let err = '下载文件出错误，请请稍后再试!'+res;
      Message({
        message:err,
        type: 'error',
        duration: 5 * 1000
      })
        reject(err);
    });
  })
}


/**
 *文件上传
 */
export function uploadFile(url,params,method){
  return new Promise((resolve, reject) => {
    request({
        url: url,
        method: method || 'post',
				data: params,
        headers:{'Content-Type': 'multipart/form-data'},
				transformRequest: [function(){
					return params;
				}],
    }).then(res=>{
      resolve(res);
    })
  });
}
